import React from 'react';
import styles from './index.less';
import imgEmpty from 'images/empty.png';

const EmptyItem = (props) => {
  const { letter = '没有找到相关内容', img, style } = props;
  return (
    <div className={styles.emptyCard} style={style}>
      <img className={styles.img} src={img || imgEmpty} />
      <p>{letter}</p>
    </div>
  );
};

export default EmptyItem;
